import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function StoreCredit() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)).catch(() => {}); }, []);

  const balance = user?.store_credit_balance || 0;
  const history = orders
    .filter((o) => o.status === "credit_issued")
    .map((o) => ({ id: o.id, amount: o.total, date: o.created_at }));

  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-12 py-12">
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Your Account</p>
      <h1 className="font-serif text-6xl tracking-tighter">Store Credit.</h1>

      <div className="mt-10 border border-[hsl(var(--accent))] p-8 tag-punch pl-14 max-w-md">
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Current Balance</p>
        <p className="font-serif text-6xl text-[hsl(var(--accent))] mt-2 tracking-tighter">
          ₹ {balance.toLocaleString("en-IN")}
        </p>
      </div>

      <div className="mt-12">
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-4">Credit History</p>
        {history.length === 0 ? (
          <p className="text-muted-foreground max-w-md leading-relaxed">
            No store credit yet. Credit is issued when a return is approved and you choose store
            credit as your refund method — it then applies automatically to future orders.
          </p>
        ) : (
          <div className="border border-foreground divide-y divide-foreground/15">
            {history.map((h) => (
              <div key={h.id} className="flex items-center justify-between px-5 py-4">
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-widest">Return credit</p>
                  <p className="font-mono text-[10px] text-muted-foreground mt-0.5">
                    Order № {h.id.slice(0, 8).toUpperCase()} · {new Date(h.date).toLocaleDateString("en-IN")}
                  </p>
                </div>
                <p className="font-serif text-xl text-[hsl(var(--accent))]">+ ₹ {h.amount.toLocaleString("en-IN")}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <p className="mt-8 font-mono text-[11px] text-muted-foreground">
        Questions about a refund? <Link to="/help" className="underline hover:text-foreground">Help &amp; Support</Link>
      </p>
    </div>
  );
}
